import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { tableStyles } from "Constants/Style";
import CancelBackButton from "components/Buttons/CancelBackButton";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import FormattedDateTime from "components/FormattedDateTime/FormattedDateTime";
import PageContainer from "components/PageContainer/PageContainer";
import TruncatedTextCell from "components/TruncatedTextCell/TruncatedTextCell";
import FilePreviewModal from "pages/Warehouse/ItemInward2/GRNDetails/FilePreviewModal/FilePreviewModal";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { createSelector } from "reselect";
import { fetchDispatchIssueToLabourById } from "slices/Inventory/Dispatch/IsuueToLabour/thunk";


const IssueToLabourViewDetails: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const dispatch = useDispatch<any>();
  const [showPreview, setShowPreview] = useState<boolean>(false);

  // Redux selector for issue to labour details
  const selectIssueToLabourDetails = createSelector(
    (state: any) => state.DispatchIssueToLabourReducer,
    (item) => ({
      selectedIssue: item.selectedIssue,
      loading: item.loadingSelected,
      error: item.error,
    })
  );

  const { selectedIssue: details, loading, error } = useSelector(selectIssueToLabourDetails);

  // Fetch data when component mounts or ID changes
  useEffect(() => {
    if (!id) {
      toast.error("ID is missing");
      navigate("/warehouse-dispatch/IssueToLabour");
      return;
    }

    dispatch(fetchDispatchIssueToLabourById({ id }));
  }, [id, dispatch, navigate]);

  // Handle errors
  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);


  return (
    <>
      <PageContainer>
        <FormHeader
          title={"View Details"}
          firstLabel="Issue to Labour"
          secondLabel="View Details"
          handleArrowClick={() => navigate("/warehouse-dispatch/IssueToLabour")}
        />

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Loading Issue To Labour data...</p>
          </div>
        ) : error ? (
          <div className="text-center py-5">
            <p className="text-danger">{error}</p>
            <CancelBackButton
              label="Back"
              onClick={() => navigate("/inventory-dispatch")}
            />
          </div>
        ) : !details ? (
          <div className="text-center py-5">
            <p>No data found</p>
            <CancelBackButton
              label="Back"
              onClick={() => navigate("/inventory-dispatch")}
            />
          </div>
        ) : (
          <div>
            <hr />
            <h6
              className="mb-3"
              style={{ fontWeight: "600", color: "#212529" }}
            >
              Dispatch Details
            </h6>
            <Row
              className="mb-2"
              style={{ marginLeft: "3px", marginTop: "2px" }}
            >
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Dispatch ID :</strong> {details?.dispatch_number || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Dispatch Date :</strong>{" "}

                  <FormattedDateTime dateString={details?.dispatch_date} format="date-only" />
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Created By :</strong> {details?.created_by_user_name || details?.created_by_user?.username || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Labour Name:</strong> {details?.labour_name || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Challan No. :</strong> {details?.challan_no || "-"}
                </p>
              </Col>
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Issue From :</strong> {details?.issued_from_warehouse.warehouse_name || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Document Uploaded :</strong>{" "}
                  {details?.document_url || details?.document ? (
                    <button
                      onClick={() => setShowPreview(true)}
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                        padding: 0,
                        textDecoration: "underline",
                      }}
                    >
                      View
                    </button>
                  ) : (
                    "-"
                  )}

                  <FilePreviewModal
                    show={showPreview}
                    onClose={() => setShowPreview(false)}
                    url={details?.document_url || details?.document}
                  />
                </p>
              </Col>
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Remark :</strong> {details?.remark || "-"}
                </p>
              </Col>
            </Row>
            <hr />
            <div className="mb-3">
              <h6
                className="mb-3"
                style={{ fontWeight: "600", color: "#212529" }}
              >
                Item Details
              </h6>
              <div className="mb-2">
                <Table hover responsive className="align-middle text-center">
                  <thead>
                    <tr>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "80px" }}
                      >
                        Sr No.
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Items
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Item Code
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Category
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Sub Category
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Unit
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Bag No.
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Total Quantity
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Dispatch Quantity
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Remarks
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {!details?.dispatch_items || details?.dispatch_items?.length === 0 ? (
                      <tr>
                        <td
                          colSpan={10}
                          style={{ ...tableStyles.cell, textAlign: "center" }}
                          className="py-3"
                        >
                          No Items found.
                        </td>
                      </tr>
                    ) : (
                      details?.dispatch_items?.map((row: any, idx: number) => {
                        return (
                          <tr key={row?.item_id || idx}>
                            <td style={tableStyles.cell}>{idx + 1}</td>

                            {/* Items */}
                            <td style={tableStyles.cell}>
                              {row?.item_name || row?.item?.item_name || "-"}
                            </td>

                            {/* Item Code */}
                            <td style={tableStyles.cell}>
                              {row?.item_code || "-"}
                            </td>

                            {/* Category */}
                            <td style={tableStyles.cell}>
                              {row?.category_name || row?.category?.category_name || "-"}
                            </td>

                            {/* Sub Category */}
                            <td style={tableStyles.cell}>
                              {row?.sub_category_name || row?.sub_category?.sub_category_name || "-"}
                            </td>

                            {/* Unit */}
                            <td style={tableStyles.cell}>
                              {row?.unit_name || row?.unit?.unit_name || row?.unit || "-"}
                            </td>

                            {/* Bag No. */}
                            <td style={tableStyles.cell}>
                              {row?.bags && row.bags.length > 0
                                ? row.bags.map((b: any) => b?.bag_no || b?.bag_number).filter(Boolean).join(", ")
                                : "-"}
                            </td>

                            {/* Total Quantity */}
                            <td style={tableStyles.cell}>
                              {row?.total_quantity || row?.required_quantity || "-"}
                            </td>

                            {/* Dispatch Quantity */}
                            <td style={tableStyles.cell}>
                              {row?.dispatch_quantity || row?.issue_quantity || "-"}
                            </td>
                            {/* Remarks */}
                            <td className="remark-cell" style={tableStyles.cell}>
                              <TruncatedTextCell
                                text={row?.remarks || row?.remark}
                                maxWidth="300px"
                                maxLines={4}
                                rowIndex={idx}
                                fallbackText="-"
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </div>
            </div>

            {/* <Row className="mb-4">
              <Col lg={7} className="mb-3">
                <div
                  style={{
                    border: `1px solid ${Colors?.grey}`,
                    borderRadius: "4px",
                  }}
                >
                  <div
                    className="d-flex align-items-center gap-2 mb-0 py-2 px-1"
                    style={{ background: Colors?.grey }}
                  >
                    <i
                      className="bi bi-chevron-down"
                      style={{ fontSize: "0.675rem", color: "#000" }}
                    ></i>
                    <h6 className="mb-0">Remark</h6>
                  </div>

                  <Form.Control
                    as="textarea"
                    rows={7}
                    value={details?.remark || "-"} // ⬅️ direct value
                    readOnly // ⬅️ view-only mode
                    style={{
                      border: "1px solid transparent",
                      borderRadius: "0px",
                      resize: "none",
                      backgroundColor: "#f8f9fa",
                      color: "#000",
                    }}
                  />
                </div>
              </Col>

              <Col lg={5} className="mb-3">
                <div
                  style={{
                    backgroundColor: Colors?.lightBlue,
                    padding: "20px",
                    borderRadius: "8px",
                    border: `1px solid ${Colors?.lightBlueBorder}`,
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Taxable Amount:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.net_taxable_value)?.toFixed(2)}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Total Discount:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_item_discounts)?.toFixed(2)}
                    </span>
                  </div>

                  <hr style={{ margin: "12px 0", borderColor: "#90caf9" }} />

                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#212529",
                      }}
                    >
                      Total Amount:
                    </span>
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "700",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_amount)?.toFixed(2)}
                    </span>
                  </div>
                </div>
              </Col>
            </Row> */}

            <div className="d-flex justify-content-center gap-3 py-3">
              <CancelBackButton
                label="Back"
                onClick={() => {
                  navigate("/inventory-dispatch");
                }}
              />
            </div>
          </div>
        )}
      </PageContainer>
    </>
  );
};

export default IssueToLabourViewDetails;
